"use client";

import React, { createContext, useContext, useState } from "react";
import { getActiveStemByUserId } from "@/actions/db/get-user-stems";
import { forceCancelConvert } from "@/actions/db/force-cancel-convert";
import {
  AuthorizedProgressContextState,
  useServiceProgressContext,
} from "@/hooks/progress-context/use-service-progress-provider";

interface SplitterProgressContextState extends AuthorizedProgressContextState {
  results: Record<string, string>;
}

const SplitterProgressContext = createContext<
  SplitterProgressContextState | undefined
>(undefined);

export const useSplitterProgressContext = (): SplitterProgressContextState => {
  const context = useContext(SplitterProgressContext);
  if (!context) {
    throw new Error(
      "useSplitterProgressContext must be used within an SplitterProgressProvider",
    );
  }
  return context;
};

export const SplitterProgressProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [results, setResults] = useState<Record<string, string>>({});

  const handleCompleteMessage = async (message: any) => {
    const savedSongs = message.songs;
    setResults({
      guitar: savedSongs["guitar"],
      piano: savedSongs["piano"],
      drums: savedSongs["drums"],
      bass: savedSongs["bass"],
      vocals: savedSongs["vocals"],
      others: savedSongs["other"],
    });
  };

  const baseContext = useServiceProgressContext({
    forceCancelProcess: forceCancelConvert,
    getActiveItemByUserId: getActiveStemByUserId,
    handleCompleteMessage,
    taskType: "split",
  });

  return (
    <SplitterProgressContext.Provider value={{ ...baseContext, results }}>
      {children}
    </SplitterProgressContext.Provider>
  );
};
